/**
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 *
 * THIS FILE IS MANAGED CENTRALLY BY THE `common-code` REPO.
 * IT COULD BE AUTO-REPLACED AT ANY TIME.
 * DO NOT MAKE CUSTOM CHANGES TO THIS FILE.
 * @see https://gitlab.com/dea-aero/development/common-code
 *
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 */
import {useState, useEffect, useCallback, useMemo} from "react";
import {Button} from "@mui/material";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";

import {useApiCallback} from "../util/Api";
import GenericSelect from "../part/GenericSelect";
import {useLoginStore} from "../useLoginStore";
import {useAppConfigStore} from "../../useAppConfigStore";
import {cellDefaults, DataGrid} from "../part/DataGrid";


const DEFAULT_PERMISSIONS = {
    'View ACLs': [
        "GET /api/acl*",
        "GET /api/acl",
        "GET /api/groups",
        "GET #/acl",
    ],
    'Set ACLs': [
        "POST /api/acl*",
        "POST /api/acl",
        "DELETE /api/acl*",
        "GET #/acl",
        "GET /api/acl*",
        "GET /api/acl",
        "GET /api/groups",
        "GET /api/apimap",
    ]
}


export default function Acl() {
    const canUser = useLoginStore(state => state.canUser);
    const canRole = useLoginStore(state => state.canRole);
    const permissions = useLoginStore(state => state.permissions);
    const pages = useAppConfigStore(state => state.pages);
    const configStorePermissions = useAppConfigStore(state => state.permissions);

    const [loading, setLoading] = useState(false)
    const [acls, setAcls] = useState([])
    const [role, setRole] = useState('')
    const [path, setPath] = useState('')
    const [paths, setPaths] = useState([])
    const [disableDel, setDisableDel] = useState(true)
    const [disableAdd, setDisableAdd] = useState(true)
    const [roles, setRoles] = useState([])
    const [apiMap, setApiMap] = useState([])
    const [apiHints, setApiHints] = useState([])
    const [canSetAcl, setCanSetAcl] = useState(false)
    const [aclSelection, setAclSelection] = useState([])
    const [endpointSelection, setEndpointSelection] = useState([])
    const [focus, setFocus] = useState('')
    const [permission, setPermission] = useState('')
    const [deleteList, setDeleteList] = useState([])

    const gotAcls = useCallback(dd => setAcls(dd.map(d => ({
        id: d.role + ' ' + d.method + ' ' + d.path,
        ...d
    }))), [setAcls])

    const getAclUpdateData = useCallback(() => {
        if (!role || !paths)
            return {}
        return paths.map(path => ({
            role,
            method: path.split(' ')[0],
            path: path.split(' ')[1]
        }))
    }, [role, paths])

    const fetchAcl = useApiCallback('GET', `/api/acl`, {setLoading, onDone: gotAcls})
    const addAcl = useApiCallback('POST', `/api/acl`, {
        data: getAclUpdateData(),
        setLoading,
        onDone: fetchAcl
    })
    const removeAcl = useApiCallback('DELETE', `/api/acl`, {
        data: deleteList,
        setLoading,
        onDone: fetchAcl
    })
    useEffect(fetchAcl, [fetchAcl, permissions])

    const fetchRoles = useApiCallback('GET', `/api/roles`, {setLoading, onDone: setRoles})
    useEffect(fetchRoles, [fetchRoles, permissions])

    const roleExists = useMemo(() => roles.find(g => g === role), [roles, role])

    const createRole = useApiCallback('POST', '/api/role', {setLoading, onDone: fetchRoles})

    const gotApiMap = useCallback(apiMap => {
        // Add the UI pages ( eg #/acl ) to the list as this doesnt come from the server
        pages.forEach(endpoint => {
            const [,path,] = endpoint
            apiMap.push('GET #'+path)
        })
        setApiMap(apiMap)
    }, [setApiMap, pages])
    const fetchApiMap = useApiCallback('GET', `/api/apimap`, {setLoading, onDone: gotApiMap})
    useEffect(fetchApiMap, [fetchApiMap, permissions])

    useEffect(() => {
        if (focus !== 'left') {
            return;
        }
        if (!aclSelection.length) {
            return;
        }
        const found = acls.filter(acl => aclSelection.indexOf(acl.id) > -1);
        const paths = found.map(acl => acl.method + ' ' + acl.path);
        if (paths.length > 1) {
            setPath(`${paths.length} paths selected`);
        } else if(found.length) {
            setRole(found[0].role);
            setPath(paths[0]);
        }
        setDeleteList(found);
        setPaths(paths);
        console.log('ASDASD', 'set paths from left', paths)
        // dont clear existing selections or it clears boxes when a row is deleted
    }, [aclSelection, focus, acls, setRole, setPaths, setPath, endpointSelection.length])

    useEffect(() => {
        if (focus !== 'right') {
            return;
        }
        if (!endpointSelection.length) {
            return;
        }
        // Check for click-selection from the endpoints list table
        const paths = apiHints.map(apihint => {
            if (endpointSelection.indexOf(apihint.id) > -1) {
                return apihint.method + ' ' + apihint.path
            }
            return null
        }).filter(a => a !== null)
        if (paths.length > 1) {
            setPath(`${paths.length} paths selected`);
        } else {
            setPath(paths[0]);
        }
        setPaths(paths)
        console.log('ASDASD', 'set right paths', paths)
    }, [endpointSelection, focus, setPath, setPaths, apiHints, aclSelection.length])

    useEffect(() => {
        const permissions = []
        acls.forEach(acl => {
            if (acl.role === role) {
                permissions.push(acl)
            }
        })
        const newhints = apiMap.map(endpoint => {
            const [m, p] = endpoint.split(' ')
            return {id: endpoint, endpoint, method: m, path: p, granted: canRole(m, p, permissions)}
        }).filter(a => a.endpoint)
        setApiHints(newhints)
    }, [acls, role, path, apiMap, pages, setApiHints, canRole])

    useEffect(() => setCanSetAcl(canUser('POST', '/api/acl')), [permissions, canUser]);

    useEffect(() => {
        const id = role + ' ' + path
        const ids = acls.map(acl => acl.id)
        console.log('role && paths.length', role, paths.length)
        setDisableDel((!paths.length && ids.indexOf(id) === -1) || !role)
        setDisableAdd(ids.indexOf(id) > -1 || !role || !paths.length)
    }, [acls, path, role, paths.length, setDisableDel, setDisableAdd])

    const aclSubject = role

    useEffect(() => {
        if (focus === 'top' && !path.endsWith('paths selected')) {
            setPaths([path])
        }
    }, [path, focus])

    const appPermissions = useMemo(() => {
        if (typeof(configStorePermissions) !== 'undefined') {
            return {...DEFAULT_PERMISSIONS, ...configStorePermissions}
        }
        return DEFAULT_PERMISSIONS
    }, [configStorePermissions])

    useEffect(() => {
        // Select the appropriate ACLs for the permission
        if (!permission)
            return

        const paths = appPermissions[permission]
        if (paths.length > 1) {
            setPath(`${paths.length} paths selected`);
        } else {
            setPath(paths[0]);
        }

        setPaths(paths)
        setFocus('permissions')
        setEndpointSelection(paths)
    }, [appPermissions, permission])

    return <Container><Stack justifyContent="center" alignItems="start">
        {canSetAcl ? <>
        <Grid container alignItems="center">
            <Grid item xs={8} md={4}>
                <GenericSelect
                    setValue={setRole}
                    value={role}
                    label="Role Name"
                    options={roles}
                    disabled={loading}
                />
            </Grid>
            <Grid item xs={8} md={4}>
                <GenericSelect
                    setValue={setPath}
                    custom={true}
                    value={path}
                    label="Path"
                    options={apiMap}
                    disabled={loading}
                    onFocus={() => setFocus('top')}
                />
            </Grid>
            {!roleExists
                ? (
                <Grid item xs={4} alignItems="center" justifyItems="center">
                    <Button sx={{width: '100%'}} disabled={loading} onClick={() => createRole({name: role})}>
                        Create Role
                    </Button>
                </Grid>
                )
                : <>
                    <Grid item xs={2} alignItems="center" justifyItems="center">
                        <Button sx={{width: '100%'}} disabled={loading || disableAdd} onClick={() => addAcl()}>
                            Add
                        </Button>
                    </Grid>
                    <Grid item xs={2} alignItems="center" justifyItems="center">
                        <Button sx={{width: '100%'}} disabled={loading || disableDel} onClick={() => removeAcl()}>
                            Delete
                        </Button>
                    </Grid>
                </>
            }
        </Grid>
        </> : ''}
            <Grid container>
                <Grid item xs={12} md={8} sx={{height: {md:'calc(100dvh - 145px)', xs:'calc(50vh - 90px)'}}}>
                    <AclGrid
                        wrapperStyle={{height: '100%'}}
                        selected={aclSelection}
                        setSelected={setAclSelection}
                        onFocus={() => setFocus('left')}
                        {...{acls, loading, role, path, fetchRoles}}
                    />
                </Grid>

                <Grid item xs={12} md={4} sx={{height: {md:'calc(100dvh - 195px)', xs:'calc(50vh - 145px)'}}}>
                    <GenericSelect
                        setValue={setPermission}
                        custom={false}
                        onKeyDown={(e) => {e.preventDefault();}}
                        value={permission}
                        label="Permission"
                        options={Object.keys(appPermissions)}
                        disabled={loading}
                    />
                    <AclRoleStatusGrid
                        wrapperStyle={{height: '100%'}}
                        selected={endpointSelection}
                        setSelected={setEndpointSelection}
                        onFocus={() => setFocus('right')}
                        {...{apiHints, loading, aclSubject}}
                    />
                </Grid>
            </Grid>
    </Stack></Container>
}


const Code = ({sx={}, children}) => {
    sx = {fontFamily: 'monospace', fontSize: {xs:'0.9em', md:'1em'}, ...sx}
    return <Box {...{sx}}>{children}</Box>
}


const AclGrid = ({acls, wrapperStyle, selected, setSelected, onFocus, fetchRoles, role, path}) => {
    const styleFlex = useCallback(cell => {
        let val = cell.value
        if ((cell.field === 'role') &&
            (role !== cell.row.role)) {
            return 'acl_deselected';
        }
        else if (cell.field === 'path' && path !== val) {
            return 'acl_deselected';
        }
        return 'acl_selected'
    }, [role, path])

    const [loading, setLoading] = useState(false)

    const renameRole = useApiCallback('POST', '/api/role', {setLoading, onDone: fetchRoles})

    const processRowUpdate = useCallback(newData => {
        const updatedRow = { ...newData, isNew: false };
        const existing =  acls.find(acl => acl.id === newData.id)
        console.log('processRowUpdate', newData, existing)

        if (existing.role !== newData.role) {
            renameRole({old_name: existing.role, name: newData.role})
        }

        // setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
        return updatedRow;
    }, [acls, renameRole])

    return <DataGrid
        wrapperStyle={wrapperStyle}
        loading={loading}
        rows={acls}
        onCellClick={onFocus}
        rowSelectionModel={selected}
        onRowSelectionModelChange={setSelected}
        columns={[
            {field: 'role', headerName: 'Role', flex: 4, ...cellDefaults, cellClassName: styleFlex, editable: true},
            {field: 'path', headerName: 'Path', flex: 4, cellClassName: styleFlex,
                valueGetter: (cell, row) => (cell?.row?.method || row?.method) + ' ' + (cell?.row?.path || row?.path),
                renderCell: cell => <code>{cell?.value}</code>,
            },
        ]}
        initialState={{
            sorting: {
                sortModel: [
                    {field:'role', sort:'asc'},
                    {field:'path', sort:'asc'}
                ],
            }
        }}
        processRowUpdate={processRowUpdate}
    />
}

const AclRoleStatusGrid = ({apiHints, wrapperStyle, selected, onFocus, setSelected, loading, aclSubject}) => {
    const disabledRows = useMemo(() => ([
        'GET /api/login',
        'GET /api/logout',
        'GET /api/error',
        'GET /api/health',
        'GET /api/person/avatar/<personid>',
    ]), [])
    const renderEndpoint = useCallback(cell => {
        let icon = cell.row.granted ? '🟢' : '🔴';
        if (disabledRows.indexOf(cell.value) > -1) {
            icon = '🟠'
        }
        return <Code>{icon} {cell.value}</Code>
    }, [disabledRows])

    return <DataGrid
        wrapperStyle={wrapperStyle}
        loading={loading}
        rows={apiHints}
        isRowSelectable={params => disabledRows.indexOf(params.row.endpoint) === -1 }
        onCellClick={onFocus}
        rowSelectionModel={selected}
        onRowSelectionModelChange={setSelected}
        columns={[
            {field: 'endpoint', headerName: aclSubject, flex: 12,renderCell: renderEndpoint},
        ]}
    />
}
